import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ContactCTA from '../../components/home/ContactCTA';
import imgP1 from '../../assets/images/Injection-molding-machine.png';
import imgP2 from '../../assets/images/Pet-beverage-filling-line.png';
import imgP3 from '../../assets/images/pet-preforn-mold.png';
import imgP4 from '../../assets/images/PET-material-lab-equipment.jpg';
import imgP5 from '../../assets/images/integratedplastic.jpg';
import imgP6 from '../../assets/images/caps-closures-mold.jpg';
import imgP7 from '../../assets/images/Medical-pharma-paxkaging-mold.jpg';
import imgP8 from '../../assets/images/Packaging&Systems.jpg';

const intravisHeroImage = 'https://24855078.fs1.hubspotusercontent-eu1.net/hubfs/24855078/Products/Bottles%20and%20Containers/SpotWatcher/intravis-spotwatcher-slash-design-700x400px.jpg';

const Intravis = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 100);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  const suggestedProducts = [
    { title: 'Injection Molding Machine', image: imgP1, path: '/products/injection-molding', description: 'Precision injection molding equipment for plastic product manufacturing.' },
    { title: 'Beverage Filling Line', image: imgP2, path: '/products/beverage-filling', description: 'Complete automated beverage production solutions with high-speed filling capabilities.' },
    { title: 'PET Preform Molds', image: imgP3, path: '/products/pet-preform', description: 'High-precision molds for PET preform production with exceptional durability.' },
    { title: 'Lab Equipment', image: imgP4, path: '/products/lab-equipment', description: 'Advanced laboratory testing and analysis equipment for quality control.' },
    { title: 'Exclusive Applications', image: imgP5, path: '/products/integrated-plastics', description: 'Integrated plastics solutions for market-ready container applications.' },
    { title: 'Caps & Closures Mold', image: imgP6, path: '/products/caps-mold', description: 'Specialized molds for producing high-quality caps and closures.' },
    { title: 'Packaging Mold', image: imgP7, path: '/products/packaging-mold', description: 'Precision manufacturing molds for diverse packaging applications.' },
    { title: 'Packaging & Systems', image: imgP8, path: '/products/packaging-systems', description: 'Advanced packaging systems for end-to-end product handling and finishing.' }
  ];

  return (
    <>
      <section
        className="relative text-white h-56 sm:h-72 md:h-96 mt-20 sm:mt-12"
        style={{
          backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.35), rgba(15, 23, 42, 0.35)), url(${intravisHeroImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/40 pointer-events-none" />
        <div className="container mx-auto px-4 h-full flex items-center">
          <div className="text-white">
            <h1 className="text-3xl md:text-4xl font-bold">Inspection Systems</h1>
            <p className="mt-2 max-w-2xl">Turnkey inspection systems for preforms, closures, bottles and decorated plastic packaging.</p>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Overview</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Intravis develops and supplies turnkey vision inspection systems for the plastic packaging industry. Their solutions are engineered to find defects early, improve process yield, and deliver trusted quality assurance for preforms, caps, bottles, containers and decorated packaging.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Intravis integrates advanced optics, image evaluation, and modular hardware to solve the quality challenges of high-speed beverage, pharmaceutical and consumer goods lines.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-xl font-semibold mb-3">Why Intravis</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Turnkey vision inspection solutions for closures, preforms, bottles and decorated packaging.</li>
                <li>High-speed systems capable of inline and offline operation.</li>
                <li>Modular design for easy integration into existing production lines.</li>
                <li>Global service and support network with expert technical backing.</li>
                <li>Advanced evaluation software for real-time decision making.</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-xl font-semibold mb-3">Product Categories</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Preform inspection systems with high-speed defect detection.</li>
                <li>CapWatcher solutions for 360° closure and thread inspection.</li>
                <li>SpotWatcher products for bottle and container surface evaluation.</li>
                <li>LabelWatcher and decoration inspection for print and IML quality.</li>
                <li>BarrierWatcher systems for layer integrity and barrier layer control.</li>
                <li>IntraVision software for centralized evaluation and reporting.</li>
              </ul>
              <Link to="/contact" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded mt-4">Contact Us</Link>
            </div>
          </div>

          <section className="py-12">
            <div className="container mx-auto px-4">
              <h3 className="text-2xl font-semibold mb-6">Explore Intravis categories</h3>
              <div className="grid gap-6 md:grid-cols-3">
                <Link to="/products/intravis/preforms" className="group block bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition-shadow">
                  <h4 className="text-xl font-semibold mb-3">Preforms</h4>
                  <p className="text-gray-600 mb-4">High-speed quality control for preform threads, bodies and cavities.</p>
                  <div className="mt-4">
                    <span className="inline-block w-full text-center bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-4 rounded transition-colors duration-300">
                      Learn more →
                    </span>
                  </div>
                </Link>
                <Link to="/products/intravis/caps-closures" className="group block bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition-shadow">
                  <h4 className="text-xl font-semibold mb-3">Caps &amp; Closures</h4>
                  <p className="text-gray-600 mb-4">360° closure inspection for contamination, print and sealing integrity.</p>
                  <div className="mt-4">
                    <span className="inline-block w-full text-center bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-4 rounded transition-colors duration-300">
                      Learn more →
                    </span>
                  </div>
                </Link>
                <Link to="/products/intravis/bottles-containers" className="group block bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition-shadow">
                  <h4 className="text-xl font-semibold mb-3">Bottles &amp; Containers</h4>
                  <p className="text-gray-600 mb-4">Comprehensive surface and geometry inspection for bottles and containers.</p>
                  <div className="mt-4">
                    <span className="inline-block w-full text-center bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-4 rounded transition-colors duration-300">
                      Learn more →
                    </span>
                  </div>
                </Link>
              </div>
            </div>
          </section>

          <div className="mt-10">
            <h3 className="text-xl font-semibold mb-4">Technology & Capabilities</h3>
            <p className="text-gray-700 leading-relaxed mb-4">Intravis systems combine high-resolution imaging hardware, precise lighting, and powerful evaluation software to perform inline and offline quality assurance. Their camera-based systems are tailored to each product segment and continuously monitor parts for defects, surface quality, and assembly integrity.</p>

            <h3 className="text-xl font-semibold mb-4">What Makes Intravis Strong</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>End-to-end turnkey systems for inspection of preforms, caps, bottles, containers and decoration.</li>
              <li>Flexible inspection platforms for different line speeds and product geometries.</li>
              <li>Inline and offline options that support maximum uptime and throughput.</li>
              <li>AI-assisted evaluation to reduce false rejects and improve defect detection.</li>
              <li>Global service and installation support with local expertise.</li>
            </ul>

            <h3 className="text-xl font-semibold mb-4">Representative Products</h3>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
                <img src="https://www.intravis.com/hubfs/Products/Preforms/PreWatcher%20Offline/intravis-preform-prewatcher%20offline-system-product-1920x1280px.png" alt="PreWatcher Offline" className="w-full h-40 object-cover" />
                <div className="p-4">
                  <h4 className="font-semibold">PreWatcher Offline</h4>
                  <p className="text-gray-600 text-sm">High-speed preform inspection in offline or inline operation.</p>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
                <img src="https://www.intravis.com/hubfs/Products/Caps%20%20and%20Closures/CapWatcher%20Q-Line/intravis-closure-capwatcher-closures-system-1920x1280px.jpg" alt="CapWatcher Q-Line" className="w-full h-40 object-cover" />
                <div className="p-4">
                  <h4 className="font-semibold">CapWatcher Q-Line</h4>
                  <p className="text-gray-600 text-sm">360° closure inspection for highest quality control.</p>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
                <img src="https://www.intravis.com/hubfs/Products/Bottles%20and%20Containers/SpotWatcher/intravis-spotwatcher-slash-design-700x400px.jpg" alt="SpotWatcher" className="w-full h-40 object-cover" />
                <div className="p-4">
                  <h4 className="font-semibold">SpotWatcher</h4>
                  <p className="text-gray-600 text-sm">Automated bottle and container inspection for defect-free production.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-10">
            <h3 className="text-xl font-semibold mb-4">Inspection Solutions</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
                <img src="https://www.intravis.com/hubfs/Products/Preforms/PreWatcher%20Offline/intravis-preform-prewatcher%20offline-system-product-1920x1280px.png" alt="PreWatcher Offline" className="w-full h-40 object-cover" />
                <div className="p-4">
                  <h4 className="font-semibold">PreWatcher Offline</h4>
                  <p className="text-gray-600 text-sm">High-speed preform inspection in offline or inline operation.</p>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
                <img src="https://www.intravis.com/hubfs/Products/Caps%20%20and%20Closures/CapWatcher%20Q-Line/intravis-closure-capwatcher-closures-system-1920x1280px.jpg" alt="CapWatcher Q-Line" className="w-full h-40 object-cover" />
                <div className="p-4">
                  <h4 className="font-semibold">CapWatcher Q-Line</h4>
                  <p className="text-gray-600 text-sm">360° closure inspection in inline and high-speed manufacturing lines.</p>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
                <img src="https://www.intravis.com/hubfs/Products/Bottles%20and%20Containers/SpotWatcher/intravis-spotwatcher-slash-design-700x400px.jpg" alt="SpotWatcher" className="w-full h-40 object-cover" />
                <div className="p-4">
                  <h4 className="font-semibold">SpotWatcher</h4>
                  <p className="text-gray-600 text-sm">Modular bottle and container inspection for a wide range of applications.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="text-center mb-16">
            <div className="inline-block">
              <span className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-2 block">
                Explore More
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Other Suggested Products
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-green-600 mx-auto mb-6"></div>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Discover our comprehensive range of cutting-edge industrial solutions designed to optimize your production efficiency and enhance manufacturing capabilities.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {suggestedProducts.map((product) => (
              <div
                key={product.title}
                onClick={() => navigate(product.path)}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer overflow-hidden border border-gray-100"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-green-600 transition-colors duration-300">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {product.description}
                  </p>
                  <div className="flex items-center text-green-600 font-semibold group-hover:translate-x-2 transition-transform duration-300">
                    <span>Learn More</span>
                    <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
};

export default Intravis;
